import { formatMoney } from 'accounting'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useAgencyProviderPackage from '@hooks/useAgencyProviderPackage'

import { AgencyProviderPackageModel } from '@models/types'

interface PackageListItemProps {
  agencyProviderPackage: AgencyProviderPackageModel,
}

const PackageListItem = (props: PackageListItemProps) => {
  const { agencyProviderPackage } = props

  const {
    callbacks: { manageAgencyProviderPackage },
    provider: {
      // @ts-expect-error TS2339
      title: providerTitle,
    },
    providerPackage: {
      // @ts-expect-error TS2339
      price,
      // @ts-expect-error TS2339
      title,
    },
  } = useAgencyProviderPackage(agencyProviderPackage)

  return (
    <DashboardModuleListItem
      isSidebar
      onClick={() => manageAgencyProviderPackage()}
      secondaryText={providerTitle}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {formatMoney(price)}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}
export default PackageListItem
